import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../header/Header';
import { SnackbarProvider } from 'notistack';

const Layout = (props: { children?: React.ReactNode, setDistrict, district, operator, setOperator, isLoggedIn, setIsLoggedIn }) => {

    return (
        <SnackbarProvider
            maxSnack={5}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
        >
            <React.Fragment>
                <Header setDistrict={props.setDistrict} district={props.district} isLoggedIn={props.isLoggedIn} setIsLoggedIn={props.setIsLoggedIn} operator={props.operator} setOperator={props.setOperator} />
                <Container fluid style={{padding: '0px 20px 0px 75px'}}>
                    {props.children}
                </Container>
            </React.Fragment>
        </SnackbarProvider>
    )
}

export default Layout;
